'use client'
import { Box, Typography, Container, Button, Stack } from '@mui/material'
import { CdnImage } from '@ui/components'
import { PresetLogoLogin, PresetLoginBackground } from '@ui/components'
import { usePathname, useRouter } from 'next/navigation';

// For error on layout
export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
	const loginImgSrc = 'https://nitsnets-b2b-back.static-servidorbeta.com/cdn-cgi/image/width=2000,format=auto/nitsnets-b2b-storage-public/hoff-develop/assets/login-bg.jpg'
	const logoUrl = process.env.NEXT_PUBLIC_LOGO_WHITE_IMAGE ?? process.env.NEXT_PUBLIC_NO_PHOTO_URL ?? '';
	const router = useRouter()
	const pathname = usePathname()
	const reload  = () => {
		const hasQuery = pathname.includes('?');
		const separator = hasQuery ? '&' : '?';
		router.push(pathname + separator + "t=" + new Date().getTime());
		reset()
	}

	return (
		<html lang="en">
			<head></head>
			<body>
				<Box sx={{ position: 'relative', height: '100vh' }}>
					<CdnImage
						src={loginImgSrc}
						preset={PresetLoginBackground}
						alt="login-img"
						sx={{ position: 'fixed', height: '100%', width: '100%' }}
						imgStyle={{ objectFit: 'cover', width: '100%', height: '100%', filter: 'brightness(0.35)' }}
					/>
					<Container maxWidth="sm" sx={{ position: 'relative', zIndex: '1', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
						<Stack spacing={10}>
                            <CdnImage src={logoUrl} preset={PresetLogoLogin} alt="b2b-logo" />
							<Typography variant="size24" color="white.main" fontWeight="700">
								Something went wrong! {typeof error.message === 'object' ? JSON.stringify(error.message) : error.message}
							</Typography>
							<Button size='large' variant="contained" color="secondary" onClick={() => reload()}>
								<Typography variant="size18">Try again</Typography>
							</Button>
						</Stack>
					</Container>
				</Box>
			</body>
		</html>
	)
}
